<template>
  <li class="navigation__list_item">
    <a
      v-if="type === 'url'"
      class="navigation_item"
      :class="{ 'navigation_item--active': isActive }"
      :href="url"
      :target="target"
      @click="$emit('navListItemLinkClick', url)"
    >
      <span class="navigation_item__name">
        <span class="navigation_item__icon"><slot name="icon"></slot></span>
        <span><slot></slot></span>
      </span>
    </a>
    <router-link
      v-else-if="type === 'link'"
      class="navigation_item"
      :class="{ 'navigation_item--active': isActive }"
      :exact="matchExact"
      :exact-path="matchExactPath"
      :to="url"
      @click.native="$emit('navListItemLinkClick', url)"
    >
      <span class="navigation_item__name">
        <span class="navigation_item__icon"><slot name="icon"></slot></span>
        <span><slot></slot></span>
      </span>
    </router-link>
    <span
      v-else
      class="navigation_item"
      :class="{ 'navigation_item--active': isActive }"
    >
      <span class="navigation_item__name">
        <span class="navigation_item__icon"><slot name="icon"></slot></span>
        <span><slot></slot></span>
      </span>
    </span>
  </li>
</template>

<script>
export default {
  name: "NavigationListItem",
  props: {
    /**
     * @vuese
     *
     * Emits 'navListItemLinkClick' with url as event data.
     *
     * The type of link that needs to be rendered
     * - 'url' (default) for a regular anchor tag
     * - 'link' for a vue router-link
     * - 'static' for a non-interactive nav list item
     */
    type: {
      type: String,
      default: "static",
    },
    /**
     * Url to link to. Required if type is not 'static'.
     */
    url: {
      type: String,
      required: false,
    },
    /**
     * Property that relates to https://router.vuejs.org/api/#exact
     * If true, exact matching of the route is required to give the element the active state.
     */
    matchExact: {
      type: Boolean,
      default: false,
    },
    /**
     * Property that relates to https://router.vuejs.org/api/#exact-path
     * If true, exact matching of the path is required to give the element the active state.
     */
    matchExactPath: {
      type: Boolean,
      default: false,
    },
    /**
     * Enforce active styling by setting to true.
     */
    isActive: {
      type: Boolean,
      default: false,
    },
    /**
     * Html target attribute value (e.g. '_blank'). Only applied when type is 'url'.
     */
    target: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style_variables/style_variables.scss";

.navigation__list_item {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

.navigation_item {
  @extend %body2_style;
  line-height: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-around;
  text-decoration: none;
  width: calc(100% + 1px);
  height: 48px;
  padding: 0px 24px;
  border-right: 2px solid rgba($white, 0);

  &.navigation_item--active,
  &.router-link-active,
  &.router-link-exact-active {
    background: rgba($blue, 0.05);
    border-right: 2px solid $blue;
    .navigation_item__icon {
      color: $blue;
    }
  }
}

.navigation_item__name {
  width: 100%;
  line-height: 20px;
  user-select: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.navigation_item__icon {
  display: inline-block;
  margin-right: 20px;
  width: 20px;
  height: 16px;
}
</style>
